import Vue from 'vue'
import Vuex from 'vuex'
import { router } from '../../../router.js'
Vue.use(Vuex)

// wizard voorbeeld
// een manier om de wizard op te bouwen, dit is echt een pril concept, moet verder wordne uitgewerkt!!
// dingen waar ik aan denk en die wellicht nog kunnen worden toegevoegd
// - om alles leesbaar te houde, per stap 1 file met actions getters en mutations, niet een aparte module! want de state moet goed deelbaar zijn
// - opslaan van localstorage, kijk hierovor naar deze plugin, die ondersteund vuex modules --> https://github.com/championswimmer/vuex-persist#readme
// - een voortgangs component, ik zou die in een apart component zetten, wellicht is het handig/nodig om een wizard in een wizard te starten, dan is het ook handig als de voortgang in een apart component zit

const state = {
  currentStep: null,
  wizard: [
    { path: 'start', enabled: true, name: 'start' },
    { path: 'cursustype', enabled: true, name: 'cursustype' },
    { path: 'elearning', enabled: false, name: 'elearning', group: 'cursustype' },
    { path: 'klassikaal', enabled: false, name: 'klassikaal', group: 'cursustype' }
  ],
  cursuskeuze: ''
}

// Getters...
const getters = {
  currentStep: state => state.currentStep,
  isFirstStep: (state, getters) => getters.wizardRouter[0].name === state.currentStep,
  isLastStep: (state, getters) => getters.wizardRouter[getters.wizardRouter.length - 1].name === state.currentStep,
  getNextStep: (state, getters) => {
    let nextstep = null
    for (let i = 0; i < getters.wizardRouter.length; i++) {
      if (getters.wizardRouter[i].name === state.currentStep) {
        if (getters.wizardRouter[i + 1]) {
          nextstep = getters.wizardRouter[i + 1].name
        }
      }
    }
    return nextstep
  },
  getPrevStep: (state, getters) => {
    let prevstep = null
    for (let i = 0; i < getters.wizardRouter.length; i++) {
      if (getters.wizardRouter[i].name === state.currentStep) {
        if (getters.wizardRouter[i - 1]) {
          prevstep = getters.wizardRouter[i - 1].name
        }
      }
    }
    return prevstep
  },
  wizardRouter: state => state.wizard.filter(r => r.enabled === true)
}

// Actions...
const actions = {
  goToNextStep: ({ state, getters, commit }) => {
    router.push('/peapp/test/wizard/' + getters.getNextStep)
    commit('setStep', getters.getNextStep)
  },
  goToPrevStep: ({ state, getters, commit }) => {
    if (state.currentStep === 'elearning' || state.currentStep === 'klassikaal') {
      commit('disableStep', 'elearning')
      commit('disableStep', 'klassikaal')
      router.push('/peapp/test/wizard/cursustype')
      commit('setStep', 'cursustype')
    } else {
      router.push('/peapp/test/wizard/' + getters.getPrevStep)
      commit('setStep', getters.getPrevStep)
    }
  },
  initWizard: ({ state, getters, commit }) => {
    commit('setStep', getters.wizardRouter[0].name)
    if (router.currentRoute.name !== getters.wizardRouter[0].name) {
      router.push('/peapp/test/wizard/' + state.currentStep)
    }
  }
}

// Mutations...
const mutations = {
  SetCursusKeuze: (state, cursuskeuze) => {
    state.wizard.filter(w => w.name === 'klassikaal')[0].enabled = false
    state.wizard.filter(w => w.name === 'elearning')[0].enabled = false
    state.wizard.filter(w => w.name === cursuskeuze)[0].enabled = true
    state.cursuskeuze = cursuskeuze
  },
  setStep: (state, stepname) => {
    state.currentStep = stepname
  },
  enableStep: (state, stepname) => {
    state.wizard.filter(w => w.name === stepname)[0].enabled = true
  },
  disableStep: (state, stepname) => {
    state.wizard.filter(w => w.name === stepname)[0].enabled = false
  }
}

// Export
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
